import { isNextApp } from "utils-lib/isNextApp"
import Image from "next/image"

const NextImageWrapper = ({
  src,
  nextImageProps,
  renderLegacyComponent,
  ...restProps
}) => {
  if (isNextApp) {
    const isLocalEnv = process.env.NEXT_PUBLIC_IS_LOCAL_ENV

    const isQAEnv =
      !isLocalEnv &&
      (process.env.NEXT_PUBLIC_NODE_ENV === "qa" ||
        process.env.NEXT_PUBLIC_NODE_ENV === "qa3")

    const isStageEnv = process.env.NEXT_PUBLIC_NODE_ENV === "cpv"

    // as per Vercel's recommendation for locking down next/image optimization with restriction on IP we are using a proxy in QA2 and QA3, not production
    // only proxy for QA environments and staging where we can do full E2E testing
    const imageSrc =
      isQAEnv || isStageEnv ? `/api/imageProxy?image=${src}` : src
    const isSvg = src.endsWith(".svg")

    return (
      <Image
        {...nextImageProps}
        {...restProps}
        src={imageSrc}
        // if loading is somehow still not provided, default loading strategy to eager to ensure best practices for above the fold images (this is also the default setting in AEM and on individual components propType definitions)
        loading={nextImageProps.loading || "eager"}
        priority={nextImageProps.priority || false}
        // SVGs are not optimized by next/image, so we need to disable optimization. We can still benefit from the other features of next/image like lazy loading and priority.
        unoptimized={isSvg || false}
      />
    )
  }

  // support legacy behavior (img,svg)
  return renderLegacyComponent({ src, ...restProps })
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// NextImageWrapper.propTypes = {
//   src: PropTypes.string.isRequired,
//   nextImageProps: PropTypes.object.isRequired,
//   renderLegacyComponent: PropTypes.func.isRequired,
// }

export default NextImageWrapper
